module.exports = __webpack_public_path__ + "img/pay_size_sel4.c6bc0c4e.png";